import * as React from 'react';
import classNames from 'classnames';
import lowerCase from 'lodash/lowerCase';
import NavigationElementDetailsMobile from '../NavigationElement/NavigationDetailsMobile/NavigationElementDetailsMobile.esm.js';
import TestCatalogSearch from '../TestCatalogSearch/TestCatalogSearch.esm.js';
import classes from './NavigationHeaderMobile.module.esm.js';

var NavigationHeaderMobileNavElement = function (_a) {
    var _b, _c;
    var _d;
    var BaseComponent = _a.BaseComponent, navElement = _a.navElement, isSearchElement = _a.isSearchElement, activeElementId = _a.activeElementId, setActiveElementId = _a.setActiveElementId, defaultSuggestions = _a.defaultSuggestions;
    if (!BaseComponent) {
        console.warn('No BaseComponent provided');
        return null;
    }
    return (React.createElement("li", { className: classNames(classes.navElementContainer, classes.noOutlineOnFocus) },
        navElement && (React.createElement(React.Fragment, null,
            React.createElement("button", { className: classes.menuButton, "data-cy": "nav_".concat(lowerCase((_d = navElement === null || navElement === void 0 ? void 0 : navElement.fields) === null || _d === void 0 ? void 0 : _d.title)), onClick: function () { return setActiveElementId(navElement.sys.id); }, onKeyDown: function (e) {
                    if (e.key !== 'Enter')
                        return;
                    setActiveElementId(navElement.sys.id);
                } },
                React.createElement(BaseComponent, { BaseComponent: BaseComponent, classes: {
                        root: classNames((_b = {},
                            _b[classes.navElementActive] = activeElementId === navElement.sys.id,
                            _b)),
                    }, key: navElement.sys.id, source: navElement })),
            React.createElement("div", { "aria-expanded": activeElementId === navElement.sys.id ? 'true' : 'false', className: classNames(classes.submenu, (_c = {}, _c[classes['submenu--show']] = activeElementId === navElement.sys.id, _c)), "data-cy": "nav_".concat(lowerCase(navElement.fields.title), "-wrapper-").concat(activeElementId === navElement.sys.id ? 'opened' : 'closed'), key: "".concat(navElement.sys.id, "_container") },
                React.createElement(NavigationElementDetailsMobile, { BaseComponent: BaseComponent, fields: navElement.fields, id: navElement.sys.id })))),
        isSearchElement && React.createElement(TestCatalogSearch, { defaultSuggestions: defaultSuggestions })));
};

export { NavigationHeaderMobileNavElement as default };
//# sourceMappingURL=NavigationHeaderMobileNavElement.esm.js.map
